import { render, staticRenderFns } from "./RTPNormForm.vue?vue&type=template&id=0f3fa1e6&"
import script from "./RTPNormForm.vue?vue&type=script&lang=js&"
export * from "./RTPNormForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports